import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const KARAT = "24k" as const;
const PATH = "/pakistan/24k";

export const Route = createFileRoute("/pakistan/24k")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `24K Gold Rate in Pakistan Today — Live 999 Pure Gold Per Tola & Per Gram | 24 Carat Sona Ka Bhao`;
    const description = `Live 24K (99.9% pure) gold rate in Pakistan — per tola, per 10 gram, per gram across Karachi, Lahore, Islamabad, Rawalpindi. 24 carat gold price in Pakistan today, refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "karat", karat: KARAT }}
      h1="24K Gold Price in Pakistan Today — Live Rate"
      intro="Live 24K (99.9% pure) gold rate for every major Pakistani sarafa bazaar — Karachi, Lahore, Islamabad, Rawalpindi, Faisalabad, Multan, Peshawar, Quetta and 14 more. Per tola, per 10 gram and per gram, refreshed every 10 minutes from international XAU/USD spot + live USD/PKR."
    />
  ),
});